import { BaseModel } from "../../model/shared/BaseModel";
import { requests } from "../../utils/helpers/api.services";
import { DATA_ENRICHMENT } from "../../utils/helpers/api.routes";

export const DataEnrichmentService = {
  getAllDataEnrichment: (params: any) =>
    requests.get(`${DATA_ENRICHMENT}`, params),
  createDataEnrichment: (params: any) =>
    requests.post(`${DATA_ENRICHMENT}`, params),
  getDataEnrichment: (id: number) => requests.get(`${DATA_ENRICHMENT}/${id}`),
  updateDataEnrichment: (params: any, id: number) =>
    requests.put(`${DATA_ENRICHMENT}/${id}`, params),
  deleteDataEnrichment: (id: number) =>
    requests.delete(`${DATA_ENRICHMENT}/${id}`),
};
